import { render, staticRenderFns } from "./sortApp.vue?vue&type=template&id=a01c73ba&scoped=true"
import script from "./sortApp.vue?vue&type=script&lang=js"
export * from "./sortApp.vue?vue&type=script&lang=js"
import style0 from "./sortApp.vue?vue&type=style&index=0&id=a01c73ba&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a01c73ba",
  null
  
)

export default component.exports